module.exports = __webpack_public_path__ + "src/assets/games/50/4.png";